import { TalkTalkParam } from 'common/types/params/talktalk'
import { TTResponseData } from 'common/types/entities/api/response'
import { TalktalkAccount, TalktalkActionResult } from 'common/types/entities/api/talktalk'
import { axios } from 'common/utils'
import { isErrorRejected } from 'common/utils/ajax/apiErrorHandler'
import { getHeaders } from 'common/utils/ajax/axios'

export async function fetchStoreTalkTalk(
  params: TalkTalkParam,
  headers?: any,
): Promise<TTResponseData<TalktalkAccount>> {
  const { talkAccountId } = params
  const result = await axios.get<TTResponseData<TalktalkAccount>>(`/v1/talktalk/accounts/${talkAccountId}`, {
    ...getHeaders(headers),
    params,
  })

  return result && result.data
}

export async function setStoreTalktalkAccount(
  params: TalkTalkParam,
  isFriend: boolean,
): Promise<TTResponseData<TalktalkActionResult>> {
  const { talkAccountId } = params
  const result = isFriend
    ? await axios.delete(`/v1/talktalk/accounts/${talkAccountId}/users`, {
        data: { ...params, [isErrorRejected]: true },
      })
    : await axios.post(`/v1/talktalk/accounts/${talkAccountId}/users`, { ...params, [isErrorRejected]: true })
  return result && result.data
}
